var _circle, _circle2, _circle3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sign up Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.85,
    cy: 6.17,
    r: 0.88
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.85,
    cy: 9.12,
    r: 0.88
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.85,
    cy: 12.06,
    r: 0.88
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.39,13.63a.78.78,0,0,1-.78.78H1.87a.78.78,0,0,1-.78-.78v-9a.78.78,0,0,1,.78-.78H8.75l.63-.62h-8A.87.87,0,0,0,.5,4.1v10a.87.87,0,0,0,.87.87H11.1a.87.87,0,0,0,.87-.87V5.49l-.59.58Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.09,2.58,6.61,9.94a.46.46,0,0,1-.65,0l-.11-.11-.71.5L5,10.15l-.26.26a.07.07,0,0,1-.1,0l-.05-.05a.07.07,0,0,1,0-.1L4.81,10l-.17-.18.52-.71L5,9a.46.46,0,0,1,0-.65L12.51,1a.45.45,0,0,1,.55-.07l.29-.28a.14.14,0,0,1,.2,0l.92.93a.14.14,0,0,1,0,.2L14.17,2A.46.46,0,0,1,14.09,2.58Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/signup.7896491ba9d7540ec801a965ee553a0d.svg";
export { ForwardRef as ReactComponent };